<template>
    <v-checkbox
        :id="id"
        ref="field"
        v-model="model"
        v-bind="$attrs"
        :class="{ 'is-invalid': invalid }"
        :name="id"
        :error="invalid"
        :color="color"
        @change="update"
    >
        <template #label>
            <slot />
        </template>

        <template #message="messageProps">
            <slot name="message" :message="messageProps.message" />
        </template>
    </v-checkbox>
</template>

<script>
    import Vue from "vue"
    import FieldMixin from "@/components/form/FieldMixin.vue"

    export default {
        mixins: [FieldMixin],

        inheritAttrs: false,
        props: {
            color: {
                type: String,
                default: "secondary",
            },
        },

        computed: {
            model: {
                get() {
                    return this.value
                },
                set(value) {
                    this.update(value)
                },
            },

        },

        mounted() {
            this.$el.querySelector(".v-label")?.addEventListener("click", event => {
                if (event.target?.nodeName === "A") {
                    event.stopPropagation()
                }
            })
        },

        methods: {
            focus(event) {
                if (this.vcform) this.vcform.emitFieldEvent("focus", this, event)
            },

            blur(event) {
                if (this.vcform) this.vcform.emitFieldEvent("blur", this, event)
            },

            update(value) {
                this.$emit("input", value)

                // submit fake blur event because checkbox doesn't have blur
                this.blur(new Event("blur"))

                // need to wait until next tick because validation was happening before the field's model value actually updated
                Vue.nextTick(() => {
                    this.$emit("validate")
                })
            },

            applyRequiredValidator(target) {
                this.applyValidator(target, "requireTrue", this.required)
            },
        },
    }
</script>
<style lang="scss">
    .v-input--checkbox {
        .v-input--selection-controls__input {
            top: 5px;
        }

        .v-input__slot {
            align-items: baseline;
        }
    }
</style>
